import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { ReloadJob } from './ReloadJob';

export class ReloadResource extends FBaseService {
  public async getReloadById(reloadId: string): Promise<ReloadJob> {
    const url: string = `/api/krp/admin/reload/${reloadId}`;

    const response: AxiosResponse = await this.apiClient.get(url);

    const result: ReloadJob = response.data.data;
    return result;
  }
}

export default ReloadResource;
